//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false */

(function () {
  const curalate = angular.module('curalate');

  curalate.directive('universalImageActionsProductizeList', () => {
    return {
      restrict: 'E',
      scope: {
        features: '=',
        trackingCategory: '@',
        isDisabled: '=',
        productsRequired: '=',
        isCatalogConnected: '<',
        orderChangedCallback: '&',
        removeProductCallback: '&',
        removeAllProductsCallback: '&',
        editProductCallback: '&',
        currentProductPosition: '<',
      },
      replace: true,
      template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-list.html'),
      controller: [
        '$modal',
        '$rootScope',
        '$scope',
        'ProductTaggingService',
        'UniversalImageActionsService',
        function (
          $modal,
          $rootScope,
          $scope,
          ProductTaggingService,
          UniversalImageActionsService,
        ) {
          const productTypes = {
            CRAWL: 'Crawl',
            UPDATE_CRAWL: 'UpdateCrawl',
          };

          $scope.model = {
            productsRequired: $scope.productsRequired,
          };

          $scope.model.editProduct = function (productIndex) {
            if (!$scope.isDisabled) {
              $scope.model.productSaveError = null;
              $scope.editProductCallback({ productIndex });
            }
          };

          $scope.model.removeProduct = function (productIndex, productStyleId) {
            if (!$scope.isDisabled) {
              $scope.model.productSaveError = null;
              $scope.removeProductCallback({ productIndex, productStyleId });
            }
          };

          $scope.model.removeAllProducts = function () {
            if (!$scope.isDisabled) {
              $scope.model.productSaveError = null;
              $scope.removeAllProductsCallback();
            }
          };

          $scope.model.isInvalidUrl = function (url) {
            return !url || url.trim().length === 0;
          };

          $scope.$on('uia:products:displayError', (event, errorMessage) => {
            $scope.model.productSaveError = errorMessage;
          });

          $scope.model.swapItems = function (dragItem, swapItem) {
            const dragPosition = dragItem.position;
            const dragLabel = dragItem.spatialTag.label;
            const swapPosition = swapItem.position;
            const swapLabel = swapItem.spatialTag.label;

            dragItem.position = swapPosition;
            dragItem.spatialTag.label = swapLabel;

            swapItem.position = dragPosition;
            swapItem.spatialTag.label = dragLabel;

            $scope.$apply();
          };

          $scope.model.dragEnded = function () {
            $scope.orderChangedCallback({ newProducts: $scope.model.products });
          };

          $scope.$on('uia:products-changed', () => {
            updateProducts(ProductTaggingService.getProducts());
          });

          $scope.$on('uia:invalid-products', ($event, errorState) => {
            updateProducts(errorState.products);
          });

          function updateProducts(newProducts) {
            $scope.$broadcast('dragSort:itemsChanged', newProducts);
            $scope.model.products = angular.copy(newProducts); // copy the list in order to safely modify it
            setCrawledInfo();
          }

          function setCrawledInfo() {
            $scope.model.products.forEach((product) => {
              if (
                product.productType &&
                (product.productType === productTypes.CRAWL ||
                  product.productType === productTypes.UPDATE_CRAWL)
              ) {
                product.isCrawled = true;
              }
            });
          }

          function initialize() {
            UniversalImageActionsService.getItemMetadataAsync().then(() => {
              $scope.model.products = angular.copy(
                ProductTaggingService.getProducts(),
              ); // copy the list in order to safely modify it
              setCrawledInfo();
            });
          }

          initialize();
        },
      ],
    };
  });
})();
